/* eslint-disable no-template-curly-in-string */
import React, { Fragment } from 'react';
import { Table, Modal, message, Divider, Alert, Select, Popconfirm, Button, Icon, Input } from 'antd';
import CelaneseAPI from '../../services';
import config from '../../config';
import ManageTowItems from '../../components/ManageTowItems';
import UserDetails from '../../components/UserDetails';
import AddCompany from '../../components/AddCompany';
import './ManageCompanies.css';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { getCompaniesData } from '../../actions/index';
import swal from 'sweetalert';
import Translation from '../../Translation';
import { utils } from '../../config';

const Option = Select.Option;

/**
 * stringSort function is for sorting the strings
 * 
 * @param {string} a 
 * @param {string} b 
 */
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}

/**
 * Class for manage company.
 *
 * @class ManageCompany
 * @extends {React.Component}
 */
class ManageCompany extends React.Component {
    constructor(props) {
        super(props);


        this.columns = [{
            title: <Translation labelName="manage_companies_tbl_hdr_company" defaultText="Company" />,
            dataIndex: 'company',
            key: 'company',
            width: 200,
            sorter: (a, b) => stringSort(a['company'], b['company']),
            onFilter: (value, record) => record['company'].toString().toLowerCase().includes(value.toLowerCase()),
        }, {
            title: <Translation labelName="manage_companies_tbl_hdr_region" defaultText="Region" />,
            dataIndex: 'region',
            key: 'region',
            width: 200,
            nocustomfilter: true,
            filters: [
                {
                    text: 'NA',
                    value: 'NA',
                },
                {
                    text: 'LA',
                    value: 'LA',
                },
                {
                    text: 'EMEA',
                    value: 'EMEA',
                },
                {
                    text: 'AP',
                    value: 'AP',
                }
            ],
            sorter: (a, b) => stringSort(a['region'], b['region']),
            onFilter: (value, record) => {
                return (record.region === value)
            }
        }, {
            title: <Translation labelName="lbl_tow_items" defaultText="Tow Items" />,
            dataIndex: 'items',
            key: 'items',
            width: 200,
            nocustomfilter: true,
            sorter: (a, b) => {
                return a.items - b.items;
            },
            onFilter: (value, record) => {
                return (record.items.toLowerCase().includes(value.toLowerCase()))
            }
        }, {
            title: <Translation labelName="lbl_action" defaultText="Action" />,
            key: 'action',
            width: 250,
            nocustomfilter: true,
            render: (rec) => (
                <span>
                    <a className="table-links" href="#" onClick={(e) => this.showManageTowItemModal(e, rec)}><Translation labelName="title_admin_manage_tow_items" defaultText="Manage Tow Items" /></a>
                    <Divider type="vertical" />
                    <a className="table-links" href="#" onClick={(e) => this.showAddCompanyModal(e, rec)}><Translation labelName="lbl_edit" defaultText="Edit" /></a>
                    <Divider type="vertical" />
                    <Popconfirm title={utils.getTranslationText('msg_r_u_sure_want_to_delete_company', "Are you sure, do you want delete '${company}' Company?").replace('${company}', rec.company)} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.confirmDeleteAction(e, rec)} onCancel={this.cancelAction} okText={<Translation labelName="lbl_yes" defaultText="Yes" />} cancelText={<Translation labelName="lbl_no" defaultText="No" />}>
                        <a className="table-links" href="#"><Translation labelName="btn_delete" defaultText="Delete" /></a>
                    </Popconfirm>
                    <Divider type="vertical" />
                    {/* <Popconfirm title={'Clone "' + rec.company + '" company to other company?'} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.showCloneCompanyModal(e, rec)} onCancel={this.cancelAction} okText="Yes" cancelText="No"> */}
                    <a className="table-links" href="#" onClick={(e) => this.showCloneCompanyModal(e, rec)}><Translation labelName="lbl_clone" defaultText="Clone" /></a>
                    {/* </Popconfirm> */}
                </span>
            ),
        }];
        this.state = {
            rows: [],
            columns: this.columns,
            visibleUser: false,
            visibleManage: false,
            visibleCompany: false,
            users: [],
            items: [],
            id: '',
            companyName: '',
            allCompanies: [],
            loading: true,
            classForLoading: false,
            isCloneCompanyModalVisible: false,
            selectedCompany: '',
            cloneRecordFrom: '',
            editCompanyData: '',
            searchText: ''
        };
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof ManageCompany
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys[0]}
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
     * onFilterDropdownVisibleChange function is for toggling the search input visibility.
     * 
     * @param {boolean} visible takes boolean as input
     * @memberof ManageCompany
     */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof ManageCompany
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     *
     * @param {array} selectedKeys
     * @param {func} handleConfirm
     * @memberof ManageCompany
     */
    handleSearch = (selectedKeys, handleConfirm) => () => {
        handleConfirm();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     *
     * @param {func} clearFilters
     * @memberof ManageCompany
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }
    /**
     * success function shows a success message when company is created/updated successfully
     * 
     * @memberof ManageCompany
     */
    success = (msg) => {
        message.success(msg || utils.getTranslationText('msg_sucessfully_updated', 'Data successfully updated.'), 2);
    };

    /**
     * error function shows an error messsage when company is not created
     * 
     * @memberof ManageCompany
     */
    error = (err) => {
        message.error(err || utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    };

    warning = () => {
        message.warning(utils.getTranslationText('msg_field_is_empty', 'The field is empty'), 2);
    };

    /**
     * confirmDeleteAction function deletes the company created by the user
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the company being deleted
     * @memberof ManageCompany
     */
    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.id) {
            CelaneseAPI.delete(config.API.updateCompanies.replace(':id', rec.id)).then(res => {
                if (!res.error) {
                    this.setState({
                        loading: true
                    }, function () {
                        this.success('"' + rec.company + " " + utils.getTranslationText('msg_dlt_success', 'deleted Successfully'));
                    });
                    this.getCompanies();
                }
            }).catch(() => {
                this.error(utils.getTranslationText('msg_error_while_deleting_company', "Error occured while deleting '${company}' Company").replace('${company}', rec.company));
            });
        }
    }

    cancelAction = () => {
    }

    /**
     * showCloneCompanyModal function opens the clone company window
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the company that has been selected from which data is to be cloned
     * @memberof ManageCompany
     */
    showCloneCompanyModal = (e, rec) => {
        e.preventDefault();
        if (rec) {
            this.setState({
                isCloneCompanyModalVisible: true,
                cloneRecordFrom: rec
            });
        }
    }

    /**
     * hideCloneCompanyModal function closes the clone company window
     * 
     * @memberof ManageCompany
     */
    hideCloneCompanyModal = () => {
        this.setState({
            isCloneCompanyModalVisible: false
        });
    }

    /**
     * handleSelectChange function sets the value of the selected company for cloning
     * @param {string} value here value is name of the company
     * @memberof ManageCompany
     */
    handleSelectChange = (value) => {
        let data = this.state.apiData;
        let result = data.find(element => element.company === value);
        if (result) {
            this.setState({
                selectedCompany: result
            });
        }
    }

    /**
     * cloneCompany function assigns the tow items to the company selected from the company being cloned
     * 
     * @memberof ManageCompany
     */
    cloneCompany = () => {
        let selectedCompany = this.state.selectedCompany;
        let that = this;

        Modal.confirm({
            title: utils.getTranslationText('msg_are_u_sure', 'Are you sure?'),
            content: '"' + this.state.cloneRecordFrom.company + " " + utils.getTranslationText('msg_tow_will_replaced', 'tow items will be replaced to') + " " + selectedCompany.company + '"',
            confirmLoading: that.state.loading,
            cancelText : utils.getTranslationText('btn_cancel', 'Cancel'),
            okText : utils.getTranslationText('btn_ok', 'OK'),
            onOk() {
                if (selectedCompany.items) {
                    that.setState({
                        loading: true
                    });
                    that.updateCloneCompanies(that.state.cloneRecordFrom, selectedCompany);
                }
            }
        })

    }

    /**
     * updateCloneCompanies function updates the database for the company assigning it identical tow items
     * @param {object} cloneRec here cloneRec is the company record that needs to be cloned
     * @param {object} selCompany here selCompany is the company record taht will receive the identical copy
     * @memberof ManageCompany
     */
    updateCloneCompanies = (cloneRec, selCompany) => {
        if (cloneRec.id && selCompany.id) {
            CelaneseAPI.patch(config.API.updateCloneCompany.replace(':id', selCompany.id).replace(':fromId', cloneRec.id), {}).then((res) => {
                if (res.data) {
                    this.hideCloneCompanyModal();
                    this.setState({
                        loading: false
                    }, () => {
                        this.success(utils.getTranslationText('msg_tow_item_cloned_success', "Tow items from '${companyFrom}' cloned Successfully to '${companyTo}'").replace('${companyFrom}', cloneRec.company).replace('${companyTo}', selCompany.company));
                    });
                    this.getCompanies();
                    this.handleManageCancel();
                } else {
                    this.setState({
                        loading: false
                    }, function () {
                        this.error(res.error);
                    });
                }
            }).catch(() => {
                this.error();
            });
        }
    }

    /**
    * showManageTowItemModal function shows the manage tow items window.
    * 
    * @param {*} e here e is an event passed
    * @param {object} record here record is the company which has been selected by the user to view its tow items.
    * @memberof ManageCompany
    */
    showManageTowItemModal = (e, record) => {
        e.preventDefault();
        this.setState({
            classForLoading: true
        }, function () {
            let _this = this;
            setTimeout(function () {
                var data = _this.state.apiData;

                if (record) {
                    let id = _this.state.rows.filter((e) => {
                        return (e && e.company === record.company);
                    })[0].id;
                    _this.setState({
                        id: id
                    });
                }

                let result = data.find(element => element.company === record.company);
                _this.setState({
                    items: result ? result.items : [],
                    companyName: result ? result.company : '',
                    visibleManage: true
                });
            }, 100);
        });
    }

    /**
     * closeLoading function closes the loading popover shown while loading the tow items for a company.
     * 
     * @memberof ManageCompany
     */
    closeLoading = () => {
        this.setState({
            classForLoading: false
        });
    }

    /**
     * handleManageCancel function closes the manage tow items window.
     * 
     * @memberof ManageCompany
     */
    handleManageCancel = () => {
        this.setState({
            visibleManage: false,
        });
    }

    /**
     * showAddCompanyModal function shows the add company window.
     * 
     * @memberof ManageCompany
     */
    showAddCompanyModal = (e, rec) => {
        e && e.preventDefault();
        this.setState({
            visibleCompany: true,
            editCompanyData: rec ? rec : ''
        });
    }

    /**
     * handleCompanyCancel function closes the add company window.
     * 
     * @memberof ManageCompany
     */
    handleCompanyCancel = () => {
        this.setState({
            visibleCompany: false,
        });
    }

    /**
     * showUserModal function shows the user window.
     * @param {*} e here e is an event passed
     * @param {object} record here record is the company which has been selected by the user.
     * @memberof ManageCompany
     */
    showUserModal = (e, record) => {
        e.preventDefault();

        var data = this.state.apiData;

        let result = data.find(element => element.company === record.company);
        if (result) {
            this.setState({
                users: result.users
            });
        }
        else {
            this.setState({
                users: []
            });
        }

        this.setState({
            visibleUser: true,
        });
    }

    /**
     * handleUserCancel function closes the user window.
     * 
     * @memberof ManageCompany
     */
    handleUserCancel = () => {
        this.setState({
            visibleUser: false,
        });
    }

    /**
     * getUpdatedItems updates the database for the updated tow items assigned to the company.
     * @param {object|array} items conatins the updated tow items
     * @memberof ManageCompany
     */
    getUpdatedItems = (items) => {
        let itemsToUpdate = [];
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            itemsToUpdate.push({
                itemlot: item['itemlot'] || item
            });
        }
        var it = { 'items': itemsToUpdate };
        CelaneseAPI.patch(config.API.updateCompanies.replace(':id', this.state.id), it).then((res) => {
            if (res.data) {
                this.success();
                this.getCompanies();
                this.handleManageCancel();
            } else {
                this.error();
            }
        }).catch(() => {
            this.error();
        });
    }

    /**
     * exportFile function is for initial check for the user to proceed further or not in case when there are no companies.
     *
     * @param {*} e here e is event passed as event
     * @memberof ManageCompany
     */

    exportFile = (e) => {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database', 'Database has zero tow items, Do you want to continue to export with empty tow items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }

    }

    /**
     * downloadFile function is for downloading of companies, in other words it's an exporting feature
     *
     * @memberof ManageCompany
     */
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_companies', 'Fetching companies'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds', 'Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting companies in excel format
         */
        CelaneseAPI.getBlob(config.API.exportCompanies).then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-companies-link');
            if (document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'companies-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'companies-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }

    componentWillMount() {
        this.getCompanies();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.assignData(nextProps);
        }
    }

    assignData(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                loading: false,
                apiData: nextProps.companiesData
            });
            this.buildCompaniesData(nextProps.companiesData);
        }
    }

    getCompanies = () => {
        getCompaniesData().then(res => {
            return res;
        });
    }

    buildCompaniesData = (res) => {
        if (!Array.isArray(res)) {
            this.setState({
                loading: false
            })
            return;
        }
        let allCompanies = [];

        let newData = res.map((obj) => {
            var Obj = {};
            allCompanies.push(obj.company);
            Obj.company = obj.company;
            Obj.items = obj.items && obj.items.length ? obj.items.length : 0;
            Obj.users = obj.users && obj.users.length ? obj.users.length : 0;
            Obj.id = obj.id;
            Obj.region = obj.region;
            return Obj;
        });

        this.setState({
            rows: newData,
            allCompanies: allCompanies,
            loading: false
        });
    }

    render() {
        const { rows, columns, visibleUser, visibleCompany, visibleManage, cloneRecordFrom } = this.state;

        const childrenFilter = [];
        const dataFilter = rows ? rows : [];
        for (let i = 0; i < dataFilter.length; i++) {
            childrenFilter.push(
                cloneRecordFrom && cloneRecordFrom.company !== dataFilter[i].company && <Option key={i} value={dataFilter[i].company}>{dataFilter[i].company}</Option>
            );
        }
        const setCustomFilters = (header) => {
            header.filterDropdown = this.filterDropdown;
            header.onFilterDropdownVisibleChange = this.onFilterDropdownVisibleChange;
            header.tableRender = this.tableRender;
        }

        columns && columns.length && columns.map(header => {
            if (!header.nocustomfilter) {
                if (header.children) {
                    header.children.map(child => setCustomFilters(child));
                } else {
                    setCustomFilters(header);
                }
            }
            return true;
        });

        return (
            <div className="manage-companies-wrapper">
                <div className="manage-companies-header">
                    <BreadcrumbHeading
                        heading={<Translation labelName="title_admin_manage_company" defaultText="Manage Companies" />} />
                    <div className="manage-companies-header__links">
                        <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button>
                        <button
                            type="button"
                            onClick={this.showAddCompanyModal}
                            className="btn btn-default add-company-link"><Translation labelName="btn_add_new_company" defaultText="Add New Company" />
                        </button>
                        {/* <a href='/help/TowPlus3.htm' target="_blank" title="Help" className="help-section m2-left">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                    </div>
                </div>

                <div className="manage-companies">
                    <div className="manage-companies-table">
                        <Table
                            dataSource={rows}
                            columns={columns}
                            rowKey={'company'}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            scroll={{ y: 'calc(100vh - 230px)' }}
                            size="middle" />
                    </div>
                    {visibleUser &&
                        <Modal title="Users"
                            visible={visibleUser}
                            footer={null}
                            onCancel={this.handleUserCancel}
                            centered
                            width={600}
                        >
                            <UserDetails users={this.state.users}></UserDetails>
                        </Modal>}
                    {this.state.visibleCompany &&
                        <Modal
                            visible={visibleCompany}
                            footer={null}
                            onCancel={this.handleCompanyCancel}
                            centered
                            width='400px'
                        >
                            <AddCompany
                                handleCompanyCancel={this.handleCompanyCancel}
                                rows={this.state.apiData}
                                editCompanyData={this.state.editCompanyData}
                                allCompanies={this.state.allCompanies}></AddCompany>
                        </Modal>}
                    {this.state.visibleManage &&
                        <Modal
                            visible={visibleManage}
                            footer={null}
                            onCancel={this.handleManageCancel}
                            centered
                            width='95%'>
                            <ManageTowItems
                                items={this.state.items}
                                getUpdatedItems={this.getUpdatedItems}
                                companyName={this.state.companyName}
                                closeLoading={this.closeLoading}>
                            </ManageTowItems>
                        </Modal>}
                    <Modal
                        visible={this.state.isCloneCompanyModalVisible}
                        footer={null}
                        onCancel={this.hideCloneCompanyModal}
                        centered
                        cancelText={utils.getTranslationText('btn_cancel', 'Cancel')}
                        okText={utils.getTranslationText('btn_ok', 'OK')}
                        width={500}>
                        <Fragment>
                            <h3><Translation labelName="hdr_clone_tow_items" defaultText="Clone Tow Items" /></h3>
                            <Alert
                                description={<Translation labelName="alert_msg_tow_items_of_the_target_company" defaultText="Cloning tow items will replace all the tow items of the target company" />}
                                type="info"
                                showIcon
                            />
                            <div className="clone-company-wrapper">
                                <label><Translation labelName="lbl_clone_from" defaultText="Clone From" />:</label>
                                <h4>{this.state.cloneRecordFrom.company}</h4>
                                <label><Translation labelName="lbl_clone_to" defaultText="Clone To" />:</label>
                                <Select
                                    className="col-md-12"
                                    onSelect={this.handleSelectChange}
                                    placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}>
                                    {childrenFilter}
                                </Select>
                                <Button type="primary" disabled={!this.state.selectedCompany} className="btn btn-default clone-company-link" loading={this.state.loading} onClick={this.cloneCompany}>
                                    <Translation labelName="lbl_clone" defaultText="Clone" />
                                </Button>
                            </div>
                        </Fragment>
                    </Modal>
                </div>
                {this.state.classForLoading && <div className="loading-overlay">
                    <div className="loading-modal">
                        <Alert
                            description={<Translation labelName="msg_loading" defaultText="Loading..." />}
                            type="info"
                            showIcon
                        />
                    </div>
                </div>}
                <a href="" className="export-companies-hidden" id="export-companies-link" download=""></a>
            </div>
        );
    }
}

const mapStateToProps = ({ companiesState }) => ({
    companiesData: companiesState.companiesData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageCompany);

ManageCompany.propTypes = {
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/containers/ManageCompanies/index.js